import { Injectable } from '@angular/core';
import { ApiService, IChatMessage, IChatOutgoingMessage, IOrder } from '@cakeiteasy/web-utils';
import { Observable } from 'rxjs';

@Injectable()
export class OrderOverviewApiService {
  constructor(protected _api: ApiService) {
  }

  /**
   * “Order” should be used here instead of “offer,”
   * but since the API request is made specifically for “offer,” it was decided to keep it this way.
   * */
  public getOffer(offerId: number | string): Observable<IOrder> {
    return this._api.get('offers', 'offers_one', { offerId });
  }

  public markRead(orderId: string): Observable<void> {
    return this._api.post('api.messages', 'order_mark_read', { orderId });
  }

  public getMessages(orderId: string): Observable<IChatMessage[]> {
    return this._api.get('api.messages', 'order_chat_messages', { orderId });
  }

  public sendMessage(orderId: string, message: IChatOutgoingMessage): Observable<IChatMessage[]> {
    return this._api.post('api.messages', 'order_chat_messages', { orderId }, message);
  }
}
